import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithProviderCountry } from "@/redux/baseQuery";

export const tripApi = createApi({
  reducerPath: "tripApi",
  baseQuery: baseQueryWithProviderCountry(),
  endpoints: () => ({}),
});
